import {observer} from "mobx-react";
import {slsCustomerCabinetStore, slsOverviewStore, slsPlacementCartStore} from "../../../store";
import {ModalDialog} from "../../ui";
import {DialogAction} from "@kroschke/react-ui";
import {SlsProcessCompleteForm} from "./SlsProcessCompleteForm";
import {SlsPlacementBatchClosingSortableTable} from "./SlsPlacementBatchClosingSortableTable";
import {useEffect} from "react";

const SlsPlacementBatchClosingDialog = observer(function SlsPlacementBatchClosingDialog() {

    const cabinetsExist = slsCustomerCabinetStore.cabinets.length > 0
    const singleCabinet = slsCustomerCabinetStore.cabinets.length === 1
    const firstCabinet = slsCustomerCabinetStore.cabinets[0]

    useEffect(() => {
        slsPlacementCartStore.cabinetRequired = cabinetsExist
    }, [cabinetsExist])

    useEffect(() => {
        if (singleCabinet) {
            slsPlacementCartStore.cabinet = firstCabinet
        } else {
            slsPlacementCartStore.cabinet = undefined
        }
    }, [singleCabinet, firstCabinet]);

    const actions: DialogAction[] = [
        {
            label: "Stapel verwerfen",
            execute: async function () {
                slsPlacementCartStore.clear()
                slsPlacementCartStore.dialogOpen = false
            },
            disabled: slsPlacementCartStore.executing,
            className: 'is-rounded is-small is-warning'
        },
        {
            label: "Abbrechen",
            execute: async function () {
                slsPlacementCartStore.dialogOpen = false
            },
            disabled: slsPlacementCartStore.executing,
            className: 'is-rounded is-small'
        },
        {
            label: `${slsPlacementCartStore.items.length} Prozess${slsPlacementCartStore.items.length !== 1 ? 'e' : ''} abschließen`,
            execute: async function () {
                await slsPlacementCartStore.submit()
                await slsOverviewStore.load()
            },
            disabled: slsPlacementCartStore.executing || !slsPlacementCartStore.ready,
            className: 'is-danger is-rounded is-small'
        }
    ]

    return <ModalDialog
        store={slsPlacementCartStore}
        actions={actions}
        title={"Einlagerungsprozesse abschließen"}
    >
        <div>
            <SlsProcessCompleteForm
                value={{
                    printer: slsPlacementCartStore.printer,
                    cabinet: slsPlacementCartStore.cabinet
                }}
                onChange={v => {
                    slsPlacementCartStore.printer = v.printer
                    slsPlacementCartStore.cabinet = v.cabinet
                }}
            />
        </div>
        <div style={{
            marginTop: '2em',
            height: '14em',
            display: 'flex',
            border: '1px dotted var(--bulma-border)'
        }}>
            <SlsPlacementBatchClosingSortableTable />
        </div>
    </ModalDialog>
})

export {
    SlsPlacementBatchClosingDialog
}
